import { useNavigate, useParams } from 'react-router';
import {
  Box, Typography, Button, CircularProgress, IconButton, Tooltip,
} from '@mui/material';
import { Add as AddIcon, ArrowBack as BackIcon } from '@mui/icons-material';
import { EntryList } from '../../components/journals/EntryList';
import { useJournals } from '../../hooks/useJournals';
import { useJournalEntries } from '../../hooks/useJournalEntries';

export const JournalEntriesPage = () => {
  const { journalId } = useParams<{ journalId: string }>();
  const navigate = useNavigate();
  const { data: journals } = useJournals();
  const journal = journals?.find(j => j.id === journalId);
  const { data: entries, isLoading } = useJournalEntries(journalId!);

  if (isLoading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}><CircularProgress /></Box>;
  }

  return (
    <Box sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, gap: 1 }}>
        <Tooltip title="All Journals">
          <IconButton onClick={() => navigate('/journals')}><BackIcon /></IconButton>
        </Tooltip>
        <Box sx={{ flex: 1 }}>
          <Typography variant="h5">{journal?.name ?? 'Journal'}</Typography>
          {journal && (
            <Typography variant="body2" color="text.secondary">
              {journal.learningLanguage} → {journal.nativeLanguage}
            </Typography>
          )}
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate(`/journals/${journalId}/entries/new`)}
        >
          New Entry
        </Button>
      </Box>

      <EntryList
        entries={entries ?? []}
        onSelect={(id) => navigate(`/journals/${journalId}/entries/${id}`)}
      />
    </Box>
  );
};
